import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import React from "react";
import { CopyButton } from "../../../components/CopyButton";
import { Body } from "../../../components/Typography";

const useStyles = createStyles(() => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacing[1],
  },
  chip: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacing[1],
    padding: `${tokens.spacing[1]} ${tokens.spacing[2]}`,
    borderRadius: tokens.radius.sm,
    background: tokens.color.semantic.bg.graySubtler,
  },
}));

interface WebhookSecretChipProps {
  webhookSecret?: string | null;
}

/** "Webhook Secret:" label with the secret in a copyable chip, per the Developer Tools design. */
export const WebhookSecretChip: React.FC<WebhookSecretChipProps> = ({ webhookSecret }) => {
  const { classes } = useStyles();

  if (!webhookSecret) return null;

  return (
    <div className={classes.row}>
      <Body weight="semibold">Webhook Secret:</Body>
      <div className={classes.chip}>
        <Body as="span" data-testid="api-keys-webhook-secret">
          {webhookSecret}
        </Body>
        <CopyButton value={webhookSecret} size="base" testId="api-keys-webhook-secret-copy" />
      </div>
    </div>
  );
};
